import React from 'react';

import './OrderScannerTablePrint.scss';

import { ScannedOrder } from '../../types/orderTypes';
import { HubSortListOrderEntry } from '../../hooks/useFetchHubSortList';

function tableLoaded(orders: HubSortListOrderEntry[]) {
  return orders.map(({ order, partnerScanCount, preciseParcelCount }) =>
    Array.apply(0, Array(order.packagesNumber)).map((currElement, index) => {
      return (
        <tr
          key={`'print'${order.id} ${index} ${Math.random()}`}
          data-order-id={`'print'${order.id} ${index}`}
        >
          <td />
          <td>{order.id}</td>
          <td> {`${order.packagesNumber}`}</td>
          <td> {`${partnerScanCount}`}</td>
          <td> {`${index + 1}/${preciseParcelCount}`}</td>
          <td>{order.senderName}</td>
        </tr>
      );
    })
  );
}

function tableNotLoaded() {
  return (
    <tr key={1} data-order-id={1}>
      <td />
      <td />
      <td />
      <td />
      <td />
      <td>
        <div />
      </td>
    </tr>
  );
}

export interface OrderTableProps {
  orders: ScannedOrder[];
}
export function OrderScannerTablePrint({
  orders = [],
}: {
  orders: HubSortListOrderEntry[];
}) {
  return (
    <div className="u-pbl">
      <table className="order-scanner-table-print">
        <thead>
          <tr>
            <th data-sort="id" data-sortmethod="number">
              {''}
            </th>
            <th data-sort="id" data-sortmethod="number">
              OrderId
            </th>
            <th data-sort="id" data-sortmethod="number">
              Parcels
            </th>
            <th data-sort="id" data-sortmethod="number">
              Retailer
            </th>
            <th data-sort="id" data-sortmethod="number">
              Hub
            </th>

            <th data-sort="delivery_name" data-sortmethod="string">
              Sender
            </th>
          </tr>
        </thead>

        <tbody>
          {orders.length > 0 ? tableLoaded(orders) : tableNotLoaded()}
        </tbody>
      </table>
    </div>
  );
}
